// Arabic strings for the adminBilling area (user directory, roles, account plans, integrations, API/webhooks, connected platforms).
// Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " (HTTP {status})": " (HTTP {status})",
  " (disabled)": " (معطّل)",
  " (no response from the delivery URL)": " (لا استجابة من عنوان التسليم)",
  " (or the {label} columns when none is saved)": " (أو أعمدة {label} عند عدم حفظ أي ربط)",
  " ({n} awaiting Xero connection)": " ({n} بانتظار ربط Xero)",
  " Matched by serial number: {serial}, by location: {location}.": " المطابقة بالرقم التسلسلي: {serial}، وبالموقع: {location}.",
  " Next run: {when}.": " التشغيل التالي: {when}.",
  " Shared secret (shown once, store it now): {secret}.": " السر المشترك (يُعرض مرة واحدة، احفظه الآن): {secret}.",
  " with this status": " بهذه الحالة",
  " · {n} properties": " · {n} عقارات",
  " · {n} property": " · عقار واحد ({n})",
  " • {n} PunchlistOS edit rejected, due in the next report": " • رُفض تعديل واحد ({n}) من PunchlistOS، يظهر في التقرير التالي",
  " • {n} PunchlistOS edits rejected, due in the next report": " • رُفضت {n} تعديلات من PunchlistOS، تظهر في التقرير التالي",
  "\"{name}\" was revoked.": "تم إلغاء \"{name}\".",
  "(routes to PM replacement queue).": "(يُحال إلى قائمة استبدال الصيانة الوقائية).",
  ", {n} failed": "، فشل {n}",
  "300+ Rooms": "أكثر من 300 غرفة",
  "A shared provider ({issuer}) is also set up for this deployment.": "تم إعداد مزوّد مشترك ({issuer}) أيضًا لهذا النشر.",
  "A user must have at least one assigned role.": "يجب أن يكون للمستخدم دور واحد مُسنَد على الأقل.",
  "A valid email address is required.": "يلزم إدخال عنوان بريد إلكتروني صالح.",
  "API and webhooks": "واجهة البرمجة وخطافات الويب",
  "API keys": "مفاتيح واجهة البرمجة",
  "API keys and webhooks": "مفاتيح واجهة البرمجة وخطافات الويب",
  "Access": "الصلاحية",
  "Access stays invitation-only: someone without an account or a pending invitation is refused.": "يبقى الوصول بالدعوة فقط: يُرفض من ليس لديه حساب أو دعوة معلّقة.",
  "Account Plans & Platform Billing": "خطط الحساب وفوترة المنصة",
  "Account suspended (day +{n} of the overdue ladder)": "الحساب موقوف (اليوم +{n} من سلّم التأخر)",
  "Account suspended / reinstated": "إيقاف الحساب / إعادة تفعيله",
  "Accounting ERP": "نظام ERP المحاسبي",
  "Active Good Standing": "نشط وبوضع سليم",
  "Active Security Role": "دور الأمان النشط",
  "Active Staff": "الموظفون النشطون",
  "Add endpoint": "إضافة نقطة استقبال",
  "Admin grants are fixed. Select another role to copy grants into it.": "صلاحيات المسؤول ثابتة. اختر دورًا آخر لنسخ الصلاحيات إليه.",
  "Administrator privileges cannot be removed from the Admin role": "لا يمكن إزالة صلاحيات المسؤول من دور المسؤول",
  "All Hotel Properties": "جميع عقارات الفنادق",
  "All Roles": "جميع الأدوار",
  "Allowed per D-09:": "مسموح وفق D-09:",
  "An administrator connects CommunityOS.": "يقوم المسؤول بربط CommunityOS.",
  "Answer": "الرد",
  "Application Module & Page": "وحدة التطبيق والصفحة",
  "Are you sure you want to deactivate {name}? They will no longer be able to sign in.": "هل أنت متأكد من تعطيل {name}؟ لن يتمكن من تسجيل الدخول بعد ذلك.",
  "As its type ({value})": "حسب نوعه ({value})",
  "Ask XI for a strategic view of your asset base. If XI is off, nothing else changes.": "اطلب من XI رؤية استراتيجية لقاعدة أصولك. إذا كان XI متوقفًا فلن يتغير شيء آخر.",
  "Asset Reference Received": "مرجع الأصل المستلَم",
  "Asset tag": "وسم الأصل",
  "Asset tag for {ref}": "وسم الأصل لـ {ref}",
  "AssetOS and PunchlistOS are in agreement.": "AssetOS وPunchlistOS متطابقان.",
  "AssetOS masters physical locations, room hierarchies, and fixed asset records. PunchlistOS masters maintenance ticket status and contractor billing.": "AssetOS هو المرجع للمواقع الفعلية وتسلسل الغرف وسجلات الأصول الثابتة. وPunchlistOS هو المرجع لحالة تذاكر الصيانة وفوترة المقاولين.",
  "AssetOS sends a signed message to your endpoint whenever something you subscribe to happens. Each message carries an event ID, when it happened, who did it, the property and an idempotency key, and is signed with your endpoint’s secret (X-Signature-SHA256).": "يرسل AssetOS رسالة موقّعة إلى نقطة الاستقبال لديك كلما وقع حدث اشتركت فيه. تحمل كل رسالة معرّف الحدث ووقت وقوعه ومن قام به والعقار ومفتاح عدم التكرار، وتُوقَّع بسر نقطة الاستقبال (X-Signature-SHA256).",
  "Assets (registered, moved, condition, status, retired, disposed, replaced)": "الأصول (تسجيل، نقل، حالة فنية، حالة، إخراج من الخدمة، استبعاد، استبدال)",
  "Assign a tier to license rooms": "أسند فئة لترخيص الغرف",
  "Assigned Hotel Property": "العقار الفندقي المُسنَد",
  "Assigned Roles": "الأدوار المُسنَدة",
  "At (UTC)": "في الساعة (UTC)",
  "At least 16 characters. A generated secret is shown once after pairing.": "16 حرفًا على الأقل. يُعرض السر المُنشأ مرة واحدة بعد الربط.",
  "Attempts": "المحاولات",
  "Audit verification cycles, discrepancy investigation, and physical variance sign-offs": "دورات التحقق بالجرد، والتحقيق في الفروقات، واعتماد الفروقات الفعلية",
  "Audits (started, completed, exceptions raised)": "عمليات الجرد (بدء، إكمال، رفع استثناءات)",
  "Authorized": "مُصرَّح",
  "Automated posting of monthly IAS 16 depreciation runs and balanced disposal gain/loss batches in AED.": "ترحيل آلي لتشغيلات الإهلاك الشهرية وفق IAS 16 ودفعات أرباح/خسائر الاستبعاد المتوازنة بالدرهم.",
  "Automation": "الأتمتة",
  "Bind": "ربط",
  "Bind to Asset": "ربط بأصل",
  "Bind {ref}": "ربط {ref}",
  "Book Policy changes": "تغييرات سياسة الدفاتر",
  "Button text": "نص الزر",
  "By Location Type": "حسب نوع الموقع",
  "CMMS Webhook": "خطاف ويب CMMS",
  "CSV Hierarchy File": "ملف التسلسل الهرمي CSV",
  "Change Plan Tier": "تغيير فئة الخطة",
  "Check connection": "فحص الاتصال",
  "Choose Property Plan Tier": "اختر فئة خطة العقار",
  "Choose a CSV file to ingest": "اختر ملف CSV لاستيعابه",
  "Choose a customer first.": "اختر عميلًا أولًا.",
  "Choose a maintenance CSV file to import": "اختر ملف CSV للصيانة لاستيراده",
  "Clear Filters": "مسح عوامل التصفية",
  "Clear all search filters": "مسح جميع عوامل البحث",
  "Client ID": "معرّف العميل",
  "Client secret": "سر العميل",
  "Closed Date": "تاريخ الإغلاق",
  "Common area": "منطقة مشتركة",
  "Common area for {code}": "منطقة مشتركة لـ {code}",
  "Common areas ({locations} locations, {assets} assets)": "المناطق المشتركة ({locations} مواقع، {assets} أصول)",
  "CommunityOS": "CommunityOS",
  "CommunityOS connected. Common areas are being published.": "تم ربط CommunityOS. يجري نشر المناطق المشتركة.",
  "CommunityOS delivery address": "عنوان التسليم في CommunityOS",
  "Configure Column Mappings": "إعداد ربط الأعمدة",
  "Connect": "ربط",
  "Connected": "متصل",
  "Connected platforms": "المنصات المتصلة",
  "Connection check": "فحص الاتصال",
  "Contract with CommunityOS": "العقد مع CommunityOS",
  "Copied": "تم النسخ",
  "Copy": "نسخ",
  "Copy Grants from Role": "نسخ الصلاحيات من دور",
  "Copy grants from another role into this one": "نسخ الصلاحيات من دور آخر إلى هذا الدور",
  "Copy it now. It is shown only once; AssetOS keeps only a protected copy it cannot display again.": "انسخه الآن. يُعرض مرة واحدة فقط؛ ويحتفظ AssetOS بنسخة محمية فقط لا يمكنه عرضها مرة أخرى.",
  "Copy link": "نسخ الرابط",
  "Cost Amount": "مبلغ التكلفة",
  "Cost, accumulated depreciation and net book value per book": "التكلفة والإهلاك المتراكم وصافي القيمة الدفترية لكل دفتر",
  "Create": "إنشاء",
  "Create key": "إنشاء مفتاح",
  "Created": "تاريخ الإنشاء",
  "Current Plan Tier": "فئة الخطة الحالية",
  "Customer Admin portal access, raw CSV data export, and billing settlement links remain 100% active.": "يبقى الوصول إلى بوابة مسؤول العميل وتصدير بيانات CSV الخام وروابط تسوية الفواتير نشطًا بالكامل.",
  "Customer Portfolio Properties & Billing Ledgers": "عقارات محفظة العميل ودفاتر الفوترة",
  "Customer:": "العميل:",
  "Day +{n}": "اليوم +{n}",
  "Deactivate": "تعطيل",
  "Deactivate (Self)": "تعطيل (حسابك)",
  "Dead letter": "رسالة متوقفة",
  "Define granular page and action privileges for each system security role": "حدّد صلاحيات تفصيلية للصفحات والإجراءات لكل دور أمان في النظام",
  "Delete \"{name}\" and its delivery log?": "حذف \"{name}\" وسجل التسليم الخاص به؟",
  "Delivered": "تم التسليم",
  "Delivered {sent} · waiting {queued} · stopped {dead}": "تم التسليم {sent} · بالانتظار {queued} · متوقف {dead}",
  "Delivered {sent} · waiting {queued} · stopped {dead} · last {last}": "تم التسليم {sent} · بالانتظار {queued} · متوقف {dead} · آخر تسليم {last}",
  "Delivered {sent}; {remaining} still waiting.": "تم تسليم {sent}؛ وما زال {remaining} بالانتظار.",
  "Delivery log": "سجل التسليم",
  "Delivery log exported as {format}.": "تم تصدير سجل التسليم بصيغة {format}.",
  "Delivery status": "حالة التسليم",
  "Departmental asset custody, transfer approvals, and retirement requests": "عهدة أصول القسم، واعتماد التحويلات، وطلبات الإخراج من الخدمة",
  "Depreciation runs posted": "ترحيل تشغيلات الإهلاك",
  "Details": "التفاصيل",
  "Details updated for {name}.": "تم تحديث بيانات {name}.",
  "Direct Debit / Wio": "خصم مباشر / Wio",
  "Disable PunchlistOS": "تعطيل PunchlistOS",
  "Disable {provider}": "تعطيل {provider}",
  "Disabled": "معطّل",
  "Discard all pending permission adjustments?": "تجاهل جميع تعديلات الصلاحيات المعلّقة؟",
  "Dismiss {ref}": "استبعاد {ref}",
  "Dispatch Invitation": "إرسال الدعوة",
  "Done": "تم",
  "Due": "الاستحقاق",
  "Due date": "تاريخ الاستحقاق",
  "Each key belongs to one of your systems. Read keys can only look; read and write keys can also record your own IDs and occupancy. Revoke a key the moment it is no longer needed.": "ينتمي كل مفتاح إلى أحد أنظمتك. مفاتيح القراءة للاطلاع فقط؛ ومفاتيح القراءة والكتابة يمكنها أيضًا تسجيل معرّفاتك الخاصة والإشغال. ألغِ المفتاح فور انتهاء الحاجة إليه.",
  "Edit Details": "تعديل البيانات",
  "Edit User Details": "تعديل بيانات المستخدم",
  "Email Address": "البريد الإلكتروني",
  "Email domains": "نطاقات البريد الإلكتروني",
  "Enable PunchlistOS": "تفعيل PunchlistOS",
  "Enable {provider}": "تفعيل {provider}",
  "Endpoint address": "عنوان نقطة الاستقبال",
  "Endpoint deleted.": "تم حذف نقطة الاستقبال.",
  "Enter role name to duplicate permissions from (e.g. Property Manager, Auditor):": "أدخل اسم الدور لنسخ الصلاحيات منه (مثل: مدير العقار، المدقق):",
  "Enter the asset tag to bind this ticket to.": "أدخل وسم الأصل لربط هذه التذكرة به.",
  "Event": "الحدث",
  "Events sent to the linked system. Failed deliveries retry automatically; dead-letter events wait for a manual retry.": "الأحداث المرسلة إلى النظام المرتبط. يُعاد تلقائيًا تسليم ما فشل؛ أما الأحداث المتوقفة فتنتظر إعادة محاولة يدوية.",
  "Events:": "الأحداث:",
  "Every day": "كل يوم",
  "Every hour": "كل ساعة",
  "Every property": "كل العقارات",
  "Exceptions resolved": "حل الاستثناءات",
  "Expired": "منتهي الصلاحية",
  "Export Raw CSV": "تصدير CSV الخام",
  "Export address (HTTPS)": "عنوان التصدير (HTTPS)",
  "Failed": "فشل",
  "Field mapping for incoming webhooks": "ربط الحقول لخطافات الويب الواردة",
  "Field operations are restricted:": "العمليات الميدانية مقيّدة:",
  "Fill from a pre-built mapping": "التعبئة من ربط جاهز",
  "Filter by property": "التصفية حسب العقار",
  "Filter by role": "التصفية حسب الدور",
  "Filter matrix": "تصفية المصفوفة",
  "Filter modules or pages...": "تصفية الوحدات أو الصفحات...",
  "Final Notice": "إشعار نهائي",
  "Final Notice (+14D)": "إشعار نهائي (+14 يومًا)",
  "Final payment notice dispatched to Customer Admin.": "يُرسل إشعار الدفع النهائي إلى مسؤول العميل.",
  "Fixed asset accounting, multi-book USALI depreciation runs, and GL journal post": "محاسبة الأصول الثابتة، وتشغيلات الإهلاك متعددة الدفاتر وفق USALI، وترحيل قيود دفتر الأستاذ",
  "For example: Group BI dashboard": "مثال: لوحة ذكاء الأعمال للمجموعة",
  "For example: Group ERP": "مثال: نظام ERP للمجموعة",
  "For residences: CommunityOS receives the common areas and the assets in them, and raises tickets against them. It runs alongside the property’s maintenance system.": "للمساكن: يستقبل CommunityOS المناطق المشتركة والأصول الموجودة فيها، ويفتح تذاكر بشأنها. ويعمل جنبًا إلى جنب مع نظام صيانة العقار.",
  "From CommunityOS:": "من CommunityOS:",
  "Full Name": "الاسم الكامل",
  "Full system configuration, security governance, and user directory management": "إعداد النظام بالكامل، وحوكمة الأمان، وإدارة دليل المستخدمين",
  "GL Export Target": "وجهة تصدير دفتر الأستاذ",
  "Generic CMMS (HotSOS / Quore)": "CMMS عام (HotSOS / Quore)",
  "Generic CMMS Column Mappings": "ربط أعمدة CMMS العام",
  "Get insight": "الحصول على الرؤية",
  "HMAC-SHA256 Shared Secret Key": "مفتاح السر المشترك HMAC-SHA256",
  "HMAC-SHA256 signature handshake succeeded! PunchlistOS endpoint responded HTTP {status}.": "نجحت مصافحة توقيع HMAC-SHA256! استجابت نقطة PunchlistOS بالرمز HTTP {status}.",
  "Header name": "اسم الترويسة",
  "Hide log": "إخفاء السجل",
  "HotSOS Maintenance": "صيانة HotSOS",
  "How": "الطريقة",
  "How it works": "آلية العمل",
  "How often": "التكرار",
  "How to call the API": "كيفية استدعاء واجهة البرمجة",
  "Identity provider address (issuer)": "عنوان مزوّد الهوية (المُصدِر)",
  "Import Maintenance CSV": "استيراد CSV الصيانة",
  "Import PMS Room List": "استيراد قائمة غرف PMS",
  "Import failed: {error}": "فشل الاستيراد: {error}",
  "Import finished: {created} created, {skipped} already imported, {queued} sent to the review queue.": "اكتمل الاستيراد: أُنشئ {created}، و{skipped} مستورد سابقًا، وأُرسل {queued} إلى قائمة المراجعة.",
  "Import now": "استيراد الآن",
  "Importing...": "جارٍ الاستيراد...",
  "Inactive / Suspended": "غير نشط / موقوف",
  "Inbound maintenance webhooks with unassigned review queue fallback for unknown asset tags.": "خطافات ويب صيانة واردة مع قائمة مراجعة احتياطية للأوسمة غير المعروفة.",
  "Inbound:": "الوارد:",
  "Ingest PMS Room List CSV": "استيعاب ملف CSV لقائمة غرف PMS",
  "Ingesting...": "جارٍ الاستيعاب...",
  "Integration Fabric Connectors & Sync": "موصلات نسيج التكامل والمزامنة",
  "Integration Review Queue": "قائمة مراجعة التكامل",
  "Invitation link": "رابط الدعوة",
  "Invite New System User": "دعوة مستخدم جديد للنظام",
  "Invite User": "دعوة مستخدم",
  "Invited": "مدعو",
  "Invited / Pending": "مدعو / قيد الانتظار",
  "Invoice": "الفاتورة",
  "Invoice Status": "حالة الفاتورة",
  "Invoices - {name}": "الفواتير - {name}",
  "Issue a new signing secret? The old one stops working now.": "إصدار سر توقيع جديد؟ سيتوقف السر القديم عن العمل فورًا.",
  "Item Name (with location)": "اسم الصنف (مع الموقع)",
  "Item Tag": "وسم الصنف",
  "Journals exported": "تصدير القيود",
  "Last Sign-In": "آخر تسجيل دخول",
  "Last checked {when}: {result}.": "آخر فحص {when}: {result}.",
  "Last reconciliation ({kind}): {result} on {when}": "آخر تسوية ({kind}): {result} في {when}",
  "Last used": "آخر استخدام",
  "Latest nights stored: {nights}": "أحدث الليالي المخزنة: {nights}",
  "Leave blank to generate a secret": "اتركه فارغًا لإنشاء سر",
  "Let your own systems read AssetOS data with an API key, and be told about changes as they happen.": "اسمح لأنظمتك بقراءة بيانات AssetOS بمفتاح واجهة برمجة، وتلقي إشعارات بالتغييرات فور حدوثها.",
  "Licence key": "مفتاح الترخيص",
  "Licensed Rooms": "الغرف المرخّصة",
  "Live Synced": "متزامن مباشرة",
  "Loading permissions…": "جارٍ تحميل الصلاحيات…",
  "Loading users…": "جارٍ تحميل المستخدمين…",
  "Locations (created, updated)": "المواقع (إنشاء، تحديث)",
  "Locations with parent, type and common-area flag": "المواقع مع الأصل والنوع ومؤشر المنطقة المشتركة",
  "Locked": "مقفل",
  "Maintenance CSV File": "ملف CSV للصيانة",
  "Maintenance CSV imported: {created} Repair Records created, {skipped} skipped as duplicates, {queued} sent to the review queue.{matched}": "تم استيراد CSV الصيانة: أُنشئ {created} سجل إصلاح، وتُخطي {skipped} لكونها مكررة، وأُرسل {queued} إلى قائمة المراجعة.{matched}",
  "Manage Assigned Roles": "إدارة الأدوار المُسنَدة",
  "Manage Roles": "إدارة الأدوار",
  "Manage enterprise user accounts, security roles, and hotel property assignments": "إدارة حسابات مستخدمي المؤسسة وأدوار الأمان وتعيينات العقارات الفندقية",
  "Manage plan tiers, room and tagged asset allowances, Xero invoicing with Wio payment links, and the suspension ladder.": "إدارة فئات الخطط، وحصص الغرف والأصول الموسومة، وفوترة Xero مع روابط دفع Wio، وسلّم الإيقاف.",
  "Manual Setup": "إعداد يدوي",
  "Mark as resumed": "وضع علامة كمستأنف",
  "Master Paired": "مرتبط كمرجع",
  "Master Rules:": "قواعد المرجعية:",
  "Master locations and assets pushed to PunchlistOS. Closing a ticket there returns the asset to service here.": "تُدفع المواقع والأصول المرجعية إلى PunchlistOS. وإغلاق التذكرة هناك يعيد الأصل إلى الخدمة هنا.",
  "Mobile barcode scanning walks and immediate maintenance incident reporting": "جولات مسح الباركود عبر الجوال والإبلاغ الفوري عن حوادث الصيانة",
  "Monthly Fee": "الرسوم الشهرية",
  "Moves (issued, returned, transferred)": "الحركات (صرف، إرجاع، تحويل)",
  "Multi-Tenant Scoping": "نطاق متعدد المستأجرين",
  "Multiple roles combine their effective system permissions.": "تُجمع صلاحيات النظام الفعلية للأدوار المتعددة.",
  "Name": "الاسم",
  "Name & Department": "الاسم والقسم",
  "Native Pairing": "ربط أصلي",
  "New secret": "سر جديد",
  "Next Billing Cycle": "دورة الفوترة التالية",
  "No": "لا",
  "No API keys yet. Create one above for the first system that needs AssetOS data.": "لا توجد مفاتيح واجهة برمجة بعد. أنشئ مفتاحًا أعلاه لأول نظام يحتاج إلى بيانات AssetOS.",
  "No Connector Paired": "لا يوجد موصل مرتبط",
  "No PMS connected for this property. An administrator enters the PMS address and credentials on the left; then rooms and occupancy can be pulled from here.": "لا يوجد نظام PMS متصل بهذا العقار. يُدخل المسؤول عنوان PMS وبيانات الاعتماد في الجهة المقابلة؛ ثم يمكن سحب الغرف والإشغال من هنا.",
  "No PunchlistOS ID map has been received yet; nothing to compare.": "لم تُستلم خريطة معرّفات PunchlistOS بعد؛ لا يوجد ما يُقارن.",
  "No active users match your search and filter criteria.": "لا يوجد مستخدمون نشطون يطابقون معايير البحث والتصفية.",
  "No answer": "لا رد",
  "No endpoints yet. Add your system’s address above, then send a test event to check it receives and verifies AssetOS messages.": "لا توجد نقاط استقبال بعد. أضف عنوان نظامك أعلاه، ثم أرسل حدثًا تجريبيًا للتأكد من أنه يستقبل رسائل AssetOS ويتحقق منها.",
  "No invoice yet": "لا توجد فاتورة بعد",
  "No outbound events{filter}. Events appear here once a connector is active and locations, assets, exceptions or PM items change.": "لا توجد أحداث صادرة{filter}. تظهر الأحداث هنا عند تفعيل موصل وتغيّر المواقع أو الأصول أو الاستثناءات أو بنود الصيانة الوقائية.",
  "No plan": "لا توجد خطة",
  "No plan assigned": "لم تُسند خطة",
  "No plan invoices have been issued for this property yet.": "لم تصدر فواتير خطة لهذا العقار بعد.",
  "No properties available.": "لا توجد عقارات متاحة.",
  "No properties in your portfolio yet.": "لا توجد عقارات في محفظتك بعد.",
  "No properties yet.": "لا توجد عقارات بعد.",
  "No property assigned": "لم يُسند عقار",
  "No reconciliation run yet": "لم تُجرَ أي تسوية بعد",
  "No tag quota yet": "لا توجد حصة أوسمة بعد",
  "No unassigned tickets. Tickets whose tag, serial number or location does not match exactly one asset are staged here instead of being dropped.": "لا توجد تذاكر غير مُسندة. التذاكر التي لا يطابق وسمها أو رقمها التسلسلي أو موقعها أصلًا واحدًا بالضبط توضع هنا بدلًا من إسقاطها.",
  "No user accounts found": "لم يُعثر على حسابات مستخدمين",
  "Not Connected": "غير متصل",
  "Not Paired": "غير مرتبط",
  "Not Subscribed": "غير مشترك",
  "Not scheduled": "غير مجدول",
  "Nothing delivered yet. Send a test event, or make a change in AssetOS that this endpoint subscribes to.": "لم يُسلَّم شيء بعد. أرسل حدثًا تجريبيًا، أو أجرِ تغييرًا في AssetOS تشترك فيه نقطة الاستقبال هذه.",
  "Occupancy": "الإشغال",
  "Offer this on the sign-in page": "عرض هذا الخيار في صفحة تسجيل الدخول",
  "One asset by its tag": "أصل واحد حسب وسمه",
  "Only if your provider issues one": "فقط إذا أصدره مزوّدك",
  "Opened the Wio payment collection portal for invoice {invoice}. Your account reinstates instantly upon payment confirmation.": "تم فتح بوابة تحصيل Wio للفاتورة {invoice}. يُعاد تفعيل حسابك فور تأكيد الدفع.",
  "Operational Status": "الحالة التشغيلية",
  "Operational suspension enforced.": "يُطبَّق الإيقاف التشغيلي.",
  "Operatively Suspended (+{n}D)": "موقوف تشغيليًا (+{n} يوم)",
  "Optional and licensed separately. Off by default; AssetOS never depends on it. XI receives only totals and counts - no names, tags, locations or people.": "اختياري ومرخّص بشكل منفصل. متوقف افتراضيًا؛ ولا يعتمد AssetOS عليه أبدًا. يستلم XI الإجماليات والأعداد فقط - دون أسماء أو أوسمة أو مواقع أو أشخاص.",
  "Organisation sign-in, your PMS, CommunityOS for residences, and optional strategic insight.": "تسجيل الدخول المؤسسي، ونظام PMS الخاص بك، وCommunityOS للمساكن، والرؤية الاستراتيجية الاختيارية.",
  "Outbound Delivery Log": "سجل التسليم الصادر",
  "Outbound Delivery URL": "عنوان التسليم الصادر",
  "Outbound Event Queue:": "قائمة الأحداث الصادرة:",
  "Outbound:": "الصادر:",
  "Overdue +{n}D": "متأخر +{n} يوم",
  "PMS": "PMS",
  "PMS Hierarchy Feed": "تغذية تسلسل PMS",
  "PMS Room List CSV": "ملف CSV لقائمة غرف PMS",
  "PMS Room List CSV parsed successfully: {rooms} new rooms, {wings} wings, and {floors} floors staged in location hierarchy ({existing} rooms already existed).": "تمت قراءة ملف CSV لقائمة غرف PMS بنجاح: {rooms} غرف جديدة و{wings} أجنحة و{floors} طوابق أُعدّت في تسلسل المواقع ({existing} غرف موجودة مسبقًا).",
  "PMS address": "عنوان PMS",
  "PMS connection saved.": "تم حفظ اتصال PMS.",
  "Paid": "مدفوعة",
  "Paid (Xero #{number})": "مدفوعة (Xero رقم {number})",
  "Pair Endpoint": "ربط نقطة الاستقبال",
  "Pair HotSOS, Quore, Flexkeeping or another maintenance system above first; its field mapping and scheduled import then appear here.": "اربط أولًا HotSOS أو Quore أو Flexkeeping أو نظام صيانة آخر أعلاه؛ ثم يظهر هنا ربط الحقول والاستيراد المجدول.",
  "Pair Webhook Endpoint": "ربط نقطة استقبال خطاف ويب",
  "Paired (disabled)": "مرتبط (معطّل)",
  "Pairing...": "جارٍ الربط...",
  "Pause": "إيقاف مؤقت",
  "Paused": "متوقف مؤقتًا",
  "Paused. Events are not collected while paused.": "تم الإيقاف المؤقت. لا تُجمع الأحداث أثناء الإيقاف.",
  "Pay via Wio Link": "الدفع عبر رابط Wio",
  "Payment past due ≥ {n} days.": "الدفع متأخر ≥ {n} يومًا.",
  "Payment reminder emailed to the Customer Admin.": "يُرسل تذكير بالدفع بالبريد إلى مسؤول العميل.",
  "Pending Activation": "بانتظار التفعيل",
  "People sign in with their organisation account; AssetOS matches their verified email to their AssetOS account.": "يسجّل المستخدمون الدخول بحساب مؤسستهم؛ ويطابق AssetOS بريدهم الموثّق مع حساباتهم في AssetOS.",
  "Periods closed": "إقفال الفترات",
  "Permission updates will apply upon user session refresh.": "تُطبَّق تحديثات الصلاحيات عند تحديث جلسة المستخدم.",
  "Permissions duplicated from {role}. Click Save Changes to commit.": "تم نسخ الصلاحيات من {role}. انقر حفظ التغييرات للاعتماد.",
  "Permissions matrix table": "جدول مصفوفة الصلاحيات",
  "Permissions updated for {role} — {count} modifications committed to security policy.": "تم تحديث صلاحيات {role} — اعتُمد {count} تعديل في سياسة الأمان.",
  "Plans tiered by licensed guest rooms and serialized asset volume.": "خطط مصنّفة حسب غرف النزلاء المرخّصة وحجم الأصول المسلسلة.",
  "Please fill out all required fields.": "يرجى تعبئة جميع الحقول المطلوبة.",
  "Point PunchlistOS at the same identity provider to use one sign-in for both products.": "وجّه PunchlistOS إلى مزوّد الهوية نفسه لاستخدام تسجيل دخول واحد للمنتجين.",
  "Pooled stock: quantity, par level, value": "المخزون المجمّع: الكمية، المستوى المعياري، القيمة",
  "Pre-built field mappings let HotSOS, Quore or Flexkeeping send their own work-order format. A scheduled import fetches the system’s CSV export every hour or day and imports it the same way as an uploaded file.": "تتيح عمليات ربط الحقول الجاهزة لأنظمة HotSOS أو Quore أو Flexkeeping إرسال أوامر العمل بصيغتها الخاصة. ويجلب الاستيراد المجدول ملف CSV المُصدَّر من النظام كل ساعة أو كل يوم ويستورده بالطريقة نفسها للملف المرفوع.",
  "Preventive maintenance due": "استحقاق الصيانة الوقائية",
  "Primary Access Role": "دور الوصول الأساسي",
  "Properties (leave all unticked for every property)": "العقارات (اترك الكل دون تحديد لجميع العقارات)",
  "Properties created": "إنشاء العقارات",
  "Properties the key may read": "العقارات التي يمكن للمفتاح قراءتها",
  "Property Code": "رمز العقار",
  "Property Integration Mappings": "ربط تكاملات العقارات",
  "Property Name": "اسم العقار",
  "Property hierarchy setup, room kit templates, and room stamping verification": "إعداد تسلسل العقار، وقوالب مجموعات الغرف، والتحقق من ختم الغرف",
  "Property plan tier updated to {tier}! Room limits and tagged asset capacities updated; automated invoicing schedule adjusted for Xero.": "تم تحديث فئة خطة العقار إلى {tier}! حُدّثت حدود الغرف وسعات الأصول الموسومة؛ وعُدّل جدول الفوترة الآلية في Xero.",
  "Publish all common areas again": "إعادة نشر جميع المناطق المشتركة",
  "Publish the latest changes now": "نشر أحدث التغييرات الآن",
  "Published {locations} common areas and {assets} assets; delivered {sent}.": "تم نشر {locations} منطقة مشتركة و{assets} أصل؛ وسُلّم {sent}.",
  "Published {staged} new event; delivered {sent}.": "تم نشر حدث جديد واحد ({staged})؛ وسُلّم {sent}.",
  "Published {staged} new events; delivered {sent}.": "تم نشر {staged} أحداث جديدة؛ وسُلّم {sent}.",
  "Pull occupancy": "سحب الإشغال",
  "Pull room list": "سحب قائمة الغرف",
  "Pulled {occupied} occupied room nights over {nights} nights.": "تم سحب {occupied} ليلة غرفة مشغولة على مدى {nights} ليلة.",
  "PunchlistOS Enterprise": "PunchlistOS للمؤسسات",
  "PunchlistOS Master Synchronization Contract": "عقد المزامنة المرجعية مع PunchlistOS",
  "PunchlistOS Native Seam": "الربط الأصلي مع PunchlistOS",
  "PunchlistOS Pairing": "الربط مع PunchlistOS",
  "Queued": "في قائمة الانتظار",
  "Quore Hotel Operations": "Quore لعمليات الفنادق",
  "Raw asset and location register CSV exported. Permitted under suspension per D-09.": "تم تصدير سجل الأصول والمواقع الخام بصيغة CSV. مسموح أثناء الإيقاف وفق D-09.",
  "Reactivate": "إعادة التفعيل",
  "Read": "قراءة",
  "Read and write": "قراءة وكتابة",
  "Received": "تاريخ الاستلام",
  "Received {received} rooms: {created} new, {existing} already set up ({total} guest rooms in total).": "تم استلام {received} غرفة: {created} جديدة، و{existing} مُعدّة مسبقًا (إجمالي غرف النزلاء {total}).",
  "Receiving, tagging, spare parts issuing, and repair work order resolution": "الاستلام والوسم وصرف قطع الغيار وإنجاز أوامر عمل الإصلاح",
  "Recent activity": "النشاط الأخير",
  "Reconciliation found {n} difference between AssetOS and PunchlistOS. AssetOS remains the master.": "وجدت التسوية فرقًا واحدًا ({n}) بين AssetOS وPunchlistOS. يبقى AssetOS هو المرجع.",
  "Reconciliation found {n} differences between AssetOS and PunchlistOS. AssetOS remains the master.": "وجدت التسوية {n} فروقات بين AssetOS وPunchlistOS. يبقى AssetOS هو المرجع.",
  "Refresh": "تحديث",
  "Register AssetOS with your identity provider (OpenID Connect, authorization code with PKCE) and allow this return address:": "سجّل AssetOS لدى مزوّد الهوية (OpenID Connect، رمز التفويض مع PKCE) واسمح بعنوان العودة هذا:",
  "Repairs recorded": "تسجيل الإصلاحات",
  "Request formats follow the vendor’s published API. Check them against your vendor API access before relying on them.": "تتبع صيغ الطلبات واجهة البرمجة المنشورة لدى المورّد. تحقّق منها مقابل صلاحيات واجهة المورّد لديك قبل الاعتماد عليها.",
  "Reset": "إعادة تعيين",
  "Reset Password": "إعادة تعيين كلمة المرور",
  "Result": "النتيجة",
  "Resume": "استئناف",
  "Resumed.": "تم الاستئناف.",
  "Retried {n} queued event: {sent} delivered, {remaining} still queued.": "أُعيدت محاولة حدث واحد ({n}) في الانتظار: سُلّم {sent}، وما زال {remaining} في الانتظار.",
  "Retried {n} queued events: {sent} delivered, {remaining} still queued.": "أُعيدت محاولة {n} أحداث في الانتظار: سُلّم {sent}، وما زال {remaining} في الانتظار.",
  "Retry failed & dead": "إعادة محاولة الفاشلة والمتوقفة",
  "Retry now": "إعادة المحاولة الآن",
  "Retry queued events": "إعادة محاولة الأحداث المنتظرة",
  "Retrying": "جارٍ إعادة المحاولة",
  "Review queue exported as {format}.": "تم تصدير قائمة المراجعة بصيغة {format}.",
  "Revoke": "إلغاء",
  "Revoke \"{name}\"? Systems using it stop working immediately.": "إلغاء \"{name}\"؟ ستتوقف الأنظمة التي تستخدمه عن العمل فورًا.",
  "Revoked": "ملغى",
  "Role Permissions Matrix": "مصفوفة صلاحيات الأدوار",
  "Role not found.": "لم يُعثر على الدور.",
  "Roles successfully updated for {name}. Changes take effect on next sign in.": "تم تحديث أدوار {name} بنجاح. تسري التغييرات عند تسجيل الدخول التالي.",
  "Room / Location Code": "رمز الغرفة / الموقع",
  "Room kits stamped": "ختم مجموعات الغرف",
  "Room list": "قائمة الغرف",
  "Rooms": "غرف",
  "Run on schedule": "التشغيل حسب الجدول",
  "Run reconciliation now": "إجراء التسوية الآن",
  "Running": "قيد التشغيل",
  "Save Changes": "حفظ التغييرات",
  "Save Plan Tier": "حفظ فئة الخطة",
  "Save Role Grants": "حفظ صلاحيات الأدوار",
  "Save mapping": "حفظ الربط",
  "Save schedule": "حفظ الجدول",
  "Scans and GL exports blocked; raw CSV data export and billing payment settlement remain open. Reinstates instantly upon payment.": "المسح وتصدير دفتر الأستاذ محظوران؛ ويبقى تصدير بيانات CSV الخام وتسوية مدفوعات الفواتير متاحين. يُعاد التفعيل فور الدفع.",
  "Scheduled": "مجدول",
  "Scheduled CSV import": "استيراد CSV مجدول",
  "Scheduled import saved. Next run: {when}.": "تم حفظ الاستيراد المجدول. التشغيل التالي: {when}.",
  "Scope": "النطاق",
  "Search by name, email, or department...": "ابحث بالاسم أو البريد الإلكتروني أو القسم...",
  "Search users": "البحث عن المستخدمين",
  "Select Property": "اختر العقار",
  "Select Property Plan Tier": "اختر فئة خطة العقار",
  "Select all security roles granted to": "اختر جميع أدوار الأمان الممنوحة لـ",
  "Select property...": "اختر العقار...",
  "Select role to configure matrix": "اختر دورًا لإعداد المصفوفة",
  "Select role to edit permissions": "اختر دورًا لتعديل الصلاحيات",
  "Select role...": "اختر الدور...",
  "Send a password reset link to {email}?": "إرسال رابط إعادة تعيين كلمة المرور إلى {email}؟",
  "Send test": "إرسال تجربة",
  "Send the key as a bearer token. Lists are paged with page and pageSize (up to 200).": "أرسل المفتاح كرمز Bearer. تُقسّم القوائم إلى صفحات باستخدام page وpageSize (حتى 200).",
  "Serial Number": "الرقم التسلسلي",
  "Shared secret (optional; AssetOS creates one when blank)": "السر المشترك (اختياري؛ ينشئ AssetOS سرًا إذا تُرك فارغًا)",
  "Shared secret (shown once):": "السر المشترك (يُعرض مرة واحدة):",
  "Showing {shown} of {total} users": "عرض {shown} من {total} مستخدم",
  "Sign-in": "تسجيل الدخول",
  "Signed Webhooks Active": "خطافات الويب الموقّعة نشطة",
  "Signing secret for this endpoint": "سر التوقيع لنقطة الاستقبال هذه",
  "Simulate +21D": "محاكاة +21 يومًا",
  "Simulating Day +21 Suspension Ladder: barcode scans, physical audits and GL exports are locked. Raw CSV export and billing payments remain accessible per D-09.": "محاكاة سلّم الإيقاف في اليوم +21: مسح الباركود والجرد الفعلي وتصدير دفتر الأستاذ مقفلة. ويبقى تصدير CSV الخام ومدفوعات الفواتير متاحين وفق D-09.",
  "Single sign-on": "تسجيل الدخول الموحد",
  "Single sign-on saved and switched on. The sign-in page now offers it.": "تم حفظ تسجيل الدخول الموحد وتفعيله. أصبحت صفحة تسجيل الدخول تعرضه.",
  "Single sign-on saved. It stays off until you switch it on.": "تم حفظ تسجيل الدخول الموحد. يبقى متوقفًا حتى تفعّله.",
  "Standard AssetOS fields": "حقول AssetOS القياسية",
  "Started": "وقت البدء",
  "Status:": "الحالة:",
  "Stock (counted, adjusted)": "المخزون (عدّ، تسوية)",
  "Stopped": "متوقف",
  "Stopped after repeated rejection": "متوقف بعد رفض متكرر",
  "Stored ({hint}) - leave blank to keep": "محفوظ ({hint}) - اتركه فارغًا للإبقاء عليه",
  "Stored - leave blank to keep": "محفوظ - اتركه فارغًا للإبقاء عليه",
  "Strategic insight": "الرؤية الاستراتيجية",
  "Suspended": "موقوف",
  "Suspension Ladder": "سلّم الإيقاف",
  "Swipe the table sideways to see every action.": "اسحب الجدول جانبيًا لرؤية جميع الإجراءات.",
  "Switch strategic insight on": "تفعيل الرؤية الاستراتيجية",
  "Sync Xero Invoices": "مزامنة فواتير Xero",
  "Synchronized plan invoices for {count} {subscriptions}: {issued} issued, {synced} sent to Xero{awaiting}{failed}.": "تمت مزامنة فواتير الخطط لعدد {count} {subscriptions}: صدر {issued}، وأُرسل {synced} إلى Xero{awaiting}{failed}.",
  "System Roles": "أدوار النظام",
  "Tagged Asset Capacity": "سعة الأصول الموسومة",
  "Tagged assets with status, condition and location": "الأصول الموسومة مع الحالة والوضع الفني والموقع",
  "Tags (bound, unbound)": "الأوسمة (ربط، فك ربط)",
  "Target Property": "العقار المستهدف",
  "Target Role": "الدور المستهدف",
  "Target System": "النظام المستهدف",
  "Tenant Organization:": "مؤسسة المستأجر:",
  "Test HMAC Handshake (HTTP 200)": "اختبار مصافحة HMAC (HTTP 200)",
  "Test event delivered (answer {status}).": "تم تسليم الحدث التجريبي (الرد {status}).",
  "Test event not accepted ({status}); it will be retried.": "لم يُقبل الحدث التجريبي ({status})؛ ستُعاد المحاولة.",
  "The Admin role always has every grant. Select another role to copy grants into it.": "يملك دور المسؤول جميع الصلاحيات دائمًا. اختر دورًا آخر لنسخ الصلاحيات إليه.",
  "The PMS answered ({hotel}).": "استجاب نظام PMS ({hotel}).",
  "The PMS answered.": "استجاب نظام PMS.",
  "The file could not be read": "تعذّرت قراءة الملف",
  "The handshake did not succeed{detail}. Events stay queued until the endpoint is reachable.": "لم تنجح المصافحة{detail}. تبقى الأحداث في الانتظار حتى يصبح الوصول إلى نقطة الاستقبال ممكنًا.",
  "The system sends work orders in the AssetOS format (event, ticketRef, assetTag, cost).": "يرسل النظام أوامر العمل بصيغة AssetOS (event، ticketRef، assetTag، cost).",
  "There is no open plan invoice to settle for this property.": "لا توجد فاتورة خطة مفتوحة لتسويتها لهذا العقار.",
  "This property has no locations yet. Set up the location registry first, then mark lobbies, pools, gyms and other shared spaces as common areas.": "لا توجد مواقع لهذا العقار بعد. أعدّ سجل المواقع أولًا، ثم حدّد الردهات والمسابح والصالات الرياضية والمساحات المشتركة الأخرى كمناطق مشتركة.",
  "Ticket Ref": "مرجع التذكرة",
  "Ticket {ref} bound to {tag}; Repair Record {number} generated and linked.": "رُبطت التذكرة {ref} بـ {tag}؛ وأُنشئ سجل الإصلاح {number} ورُبط.",
  "Ticket {ref} dismissed from the review queue.": "استُبعدت التذكرة {ref} من قائمة المراجعة.",
  "Tickets from CommunityOS:": "التذاكر من CommunityOS:",
  "Tiers enforce physical room stamping limits and serialized tag capacities. Invoicing adjusts on the 1st of the next month via Xero.": "تفرض الفئات حدود ختم الغرف الفعلية وسعات الأوسمة المسلسلة. وتُعدَّل الفوترة في الأول من الشهر التالي عبر Xero.",
  "To (not included)": "إلى (غير مشمول)",
  "To CommunityOS:": "إلى CommunityOS:",
  "Token": "الرمز",
  "Token in a header": "رمز في الترويسة",
  "Total Accounts": "إجمالي الحسابات",
  "Total Rooms": "إجمالي الغرف",
  "Tries": "المحاولات",
  "Type the CSV column header that holds each Repair Record field. Each row needs an item tag, a serial number or a room / location code (add the item name when a room holds several assets). Rows that do not match exactly one asset go to the review queue. Mappings are saved for this property; re-uploading the same file skips work orders that were already imported. Import a file here, or set up a scheduled import from the system’s export address under Automation below.": "اكتب عنوان عمود CSV الذي يحتوي كل حقل من حقول سجل الإصلاح. يحتاج كل صف إلى وسم صنف أو رقم تسلسلي أو رمز غرفة / موقع (أضف اسم الصنف عندما تحتوي الغرفة على عدة أصول). الصفوف التي لا تطابق أصلًا واحدًا بالضبط تذهب إلى قائمة المراجعة. يُحفظ الربط لهذا العقار؛ وإعادة رفع الملف نفسه تتخطى أوامر العمل المستوردة سابقًا. استورد ملفًا هنا، أو أعدّ استيرادًا مجدولًا من عنوان تصدير النظام ضمن الأتمتة أدناه.",
  "Unassigned Tag Queue:": "قائمة الأوسمة غير المُسندة:",
  "Unpaired": "غير مرتبط",
  "Up to {n} Rooms": "حتى {n} غرفة",
  "Update connection": "تحديث الاتصال",
  "Upgrade to {tier}": "الترقية إلى {tier}",
  "Upload & Ingest Hierarchy": "رفع التسلسل واستيعابه",
  "Upload property management system room list CSV (Opera, Protel, Mews) to automatically stage building, wing, floor, and room hierarchy nodes. Columns: Building, Wing, Floor, Room.": "ارفع ملف CSV لقائمة الغرف من نظام إدارة العقار (Opera، Protel، Mews) لإعداد عُقد تسلسل المبنى والجناح والطابق والغرفة تلقائيًا. الأعمدة: Building، Wing، Floor، Room.",
  "Use the test identity provider": "استخدام مزوّد الهوية التجريبي",
  "User directory roster": "قائمة دليل المستخدمين",
  "User {name} has been deactivated.": "تم تعطيل المستخدم {name}.",
  "User {name} has been reactivated.": "تمت إعادة تفعيل المستخدم {name}.",
  "Username": "اسم المستخدم",
  "Username and password": "اسم المستخدم وكلمة المرور",
  "Users pagination": "ترقيم صفحات المستخدمين",
  "Uses this property’s saved column mapping{preset}. Work orders already imported are skipped; rows that match no single asset go to the review queue. Failures are emailed to your administrators.": "يستخدم ربط الأعمدة المحفوظ لهذا العقار{preset}. تُتخطى أوامر العمل المستوردة سابقًا؛ وتذهب الصفوف التي لا تطابق أصلًا واحدًا إلى قائمة المراجعة. تُرسل حالات الفشل بالبريد إلى المسؤولين لديك.",
  "Verify OAuth2 Token": "التحقق من رمز OAuth2",
  "View Invoices": "عرض الفواتير",
  "View invoices for {name}": "عرض فواتير {name}",
  "View permission automatically enabled for {action} action.": "تم تفعيل صلاحية العرض تلقائيًا لإجراء {action}.",
  "Waiting or retrying": "بالانتظار أو قيد إعادة المحاولة",
  "Warning": "تحذير",
  "Warning (+7D)": "تحذير (+7 أيام)",
  "Warning email and banner in the web portal.": "بريد تحذيري وشريط تنبيه في بوابة الويب.",
  "Webhook connectors for PunchlistOS, CMMS systems (HotSOS, Quore), Xero journals and PMS room imports.": "موصلات خطافات الويب لـ PunchlistOS وأنظمة CMMS (HotSOS، Quore) وقيود Xero واستيراد غرف PMS.",
  "Webhook endpoint paired and verified with cryptographic shared secret. Inbound address: {path}.{generated}": "تم ربط نقطة استقبال خطاف الويب والتحقق منها بسر مشترك مشفّر. العنوان الوارد: {path}.{generated}",
  "Webhooks": "خطافات الويب",
  "Whole portfolio": "المحفظة بالكامل",
  "Wio payment links configured": "روابط دفع Wio مُعدّة",
  "Wio payment links not configured": "روابط دفع Wio غير مُعدّة",
  "Work Order Reference": "مرجع أمر العمل",
  "Work blocked during the suspension - ready to resume": "أعمال حُظرت أثناء الإيقاف - جاهزة للاستئناف",
  "Work refused while suspended": "أعمال رُفضت أثناء الإيقاف",
  "Write access: push occupied room nights per night": "صلاحية الكتابة: إرسال ليالي الغرف المشغولة لكل ليلة",
  "Write access: record your own ID for an asset or location": "صلاحية الكتابة: تسجيل معرّفك الخاص لأصل أو موقع",
  "XI address": "عنوان XI",
  "XI connection": "اتصال XI",
  "XI connection saved and switched on.": "تم حفظ اتصال XI وتفعيله.",
  "XI connection saved; it stays off.": "تم حفظ اتصال XI؛ ويبقى متوقفًا.",
  "Xero Manual Journal Connector": "موصل القيود اليدوية في Xero",
  "Xero connected": "Xero متصل",
  "Xero not configured": "Xero غير مُعدّ",
  "Yes": "نعم",
  "You": "أنت",
  "You cannot deactivate your own account": "لا يمكنك تعطيل حسابك",
  "You cannot remove the Admin role from your own active session.": "لا يمكنك إزالة دور المسؤول من جلستك النشطة.",
  "You have {n} unsaved permission changes. Discard and switch role?": "لديك {n} تغييرات غير محفوظة على الصلاحيات. هل تريد تجاهلها وتبديل الدور؟",
  "Your new API key": "مفتاح واجهة البرمجة الجديد",
  "answered": "استجاب",
  "barcode scanning, audits, stock counts, custody moves and General Ledger journal exports are locked. Work refused now is listed here so it can resume after payment.": "مسح الباركود والجرد وعدّ المخزون وحركات العهدة وتصدير قيود دفتر الأستاذ العام مقفلة. تُدرج هنا الأعمال المرفوضة حاليًا لاستئنافها بعد الدفع.",
  "dead letter": "متوقفة",
  "e.g. Rachel Adams": "مثال: راشيل آدامز",
  "event": "حدث",
  "events": "أحداث",
  "failed": "فشل",
  "healthy": "سليم",
  "in agreement": "متطابق",
  "no": "لا",
  "no answer": "لا رد",
  "not configured": "غير مُعدّ",
  "not reachable": "تعذّر الوصول",
  "page": "صفحة",
  "pages": "صفحات",
  "paused": "متوقف مؤقتًا",
  "pending": "قيد الانتظار",
  "queued": "في الانتظار",
  "sent": "تم الإرسال",
  "subscription": "اشتراك",
  "subscriptions": "اشتراكات",
  "synced": "متزامن",
  "user": "مستخدم",
  "users": "مستخدمين",
  "yes": "نعم",
  "{action} on {page} for {role}": "{action} على {page} لـ {role}",
  "{amount} / Month": "{amount} / شهريًا",
  "{created} created, {skipped} skipped, {queued} to review": "أُنشئ {created}، وتُخطي {skipped}، و{queued} للمراجعة",
  "{label} fields": "حقول {label}",
  "{message}: line {line} - {detail}": "{message}: السطر {line} - {detail}",
  "{name} ({n} Rooms)": "{name} ({n} غرفة)",
  "{n} blocked item marked as resumed. Re-run them from their pages (scans, audits, counts, moves or journal exports).": "تم وضع علامة الاستئناف على بند محظور واحد ({n}). أعد تشغيله من صفحته (المسح أو الجرد أو العدّ أو الحركات أو تصدير القيود).",
  "{n} blocked items marked as resumed. Re-run them from their pages (scans, audits, counts, moves or journal exports).": "تم وضع علامة الاستئناف على {n} بنود محظورة. أعد تشغيلها من صفحاتها (المسح أو الجرد أو العدّ أو الحركات أو تصدير القيود).",
  "{n} changes not saved": "{n} تغييرات غير محفوظة",
  "{n} difference": "فرق واحد ({n})",
  "{n} differences": "{n} فروقات",
  "{n} pending": "{n} قيد الانتظار",
  "{n} pending tickets": "{n} تذاكر معلّقة",
  "{n} properties": "{n} عقارات",
  "{n} queued • Reconnect buffer active": "{n} في الانتظار • مخزن إعادة الاتصال نشط",
  "{n} rooms": "{n} غرفة",
  "{pct}% capacity used": "استُخدم {pct}% من السعة",
  "{pct}% tag quota used": "استُخدم {pct}% من حصة الأوسمة",
  "{provider} connector disabled.": "تم تعطيل موصل {provider}.",
  "{provider} connector enabled.": "تم تفعيل موصل {provider}.",
  "{provider} inbound:": "وارد {provider}:",
  "{provider} webhooks now use the standard AssetOS fields.": "تستخدم خطافات ويب {provider} الآن حقول AssetOS القياسية.",
  "{provider} webhooks now use the {preset} field mapping.": "تستخدم خطافات ويب {provider} الآن ربط حقول {preset}.",
  "{tier} Hospitality Plan": "خطة الضيافة {tier}",
  "{tier} Plan ({rooms} • AED {fee}/mo)": "خطة {tier} ({rooms} • AED {fee}/شهريًا)",
  "{used} / {limit} Max": "{used} / {limit} كحد أقصى",
};
